<template>
  <a class="btn btn-warning" href="javascript:void(0);" @click="show">Задать вопрос</a>
</template>

<script>
import FaqForm from "@/components/core/FaqForm.vue";

export default {
  name: 'FaqLink',
  components: FaqForm,
  methods: {
    show () {
      this.$modal.show(FaqForm, {
        product: this.product
      },{
        height: 'auto'
      })
    }
  }
}
</script>